<template>
  <div class="assets-offline">
    <div class="box is-shadowless">
      <div class="map-container">
        <div class="columns is-multiline">
          <div class="column is-12">
            <assets-offline-map
              :map-config="mapConfig"
              :show-filters="true"
              :can-import="true"
              :can-export="true"
              fetch-on="pan"
              ref="assetsOfflineMap"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssetsOfflineMap from "@/components/AssetsOfflineMap";

export default {
  components: {
    AssetsOfflineMap
  },
  data: () => ({
    mapConfig: {
      height: 450,
      devTools: true,
      devToolsPosition: "left"
    }
  })
};
</script>



// WEBPACK FOOTER //
// src/components/pages/AssetsOffline/developer/index.vue